export default __webpack_public_path__ + "static/media/carmel-modified.5575281a.png";